import { render, staticRenderFns } from "./WeakPoint.vue?vue&type=template&id=6dbed675&"
import script from "./WeakPoint.vue?vue&type=script&lang=ts&"
export * from "./WeakPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports